import CollectionApi from 'client/api/v2/CollectionApi';
import CommandsApi from 'client/api/v2/CommandsApi';

class CommandQueueWorkflowApi extends CollectionApi {
  constructor() {
    super('/api/v2/queuedcommand/workflows', {
      skip: 0,
      sort: '-createDate',
      search: {
        fields: ['name'],
        searchTerm: '',
      },
    });
  }

  cancelCommandQueue(queueId) {
    return this.axios.delete(`/api/v2/commandqueue/${queueId}`);
  }

  async fetch(...args) {
    const res = await super.fetch(...args);

    if (res.results.length > 0) {
      const commands = await CommandsApi.search({
        filter: {
          or: res.results.map(w => ({ _id: w.command })),
        },
      });

      res.results = res.results.reduce((acc, w) => {
        const command = commands.data.results.find(c => w.command === c._id);

        if (command) {
          acc.push({
            ...w,
            name: w.name || command.name,
            operatingSystem: command.commandType,
            workflowInstanceId: w.id,
          });
        }

        return acc;
      }, []);
    }

    return res;
  }
}

export default new CommandQueueWorkflowApi();
